<i18n>
{
  "fr": {
    "mandat": "Mandat",
    "administratif": "administratif"
  }
}
</i18n>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30.001 13"
    class="vue-icon secure-reinsurance__payment-method-icon secure-reinsurance__payment-method-icon--sepa-mandate"
  >
    <g
      id="Logo_Mandat_Administratif"
      data-name="Logo / Mandat Administratif"
      transform="translate(0)"
    >
      <text
        x="0"
        y="6"
        font-family="Arial, Helvetica, sans-serif"
        font-weight="700"
        font-size="4.9"
        letter-spacing="-0.05"
        fill="#171717"
      >
        {{ $t('mandat') }}
      </text>
      <text
        x="0"
        y="12.4"
        font-family="Arial, Helvetica, sans-serif"
        font-weight="700"
        font-size="4.9"
        letter-spacing="-0.05"
        fill="#132e94"
      >
        {{ $t('administratif') }}
      </text>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconLogoSepa',
};
</script>
